<template>
  <a-modal :open="open" title="Contacto con ventas" centered @cancel="handleClose">
    <p>
      Enviaremos tu solicitud a nuestro equipo de soporte. ¡Te estaremos respondiendo lo más pronto
      posible!
    </p>

    <p>
      <strong>Nombre de empresa:</strong>

      {{ user.customer.workspace }}
    </p>

    <p><strong>Datos personales</strong></p>

    <a-form layout="vertical" :model="formState">
      <div class="flex">
        <a-form-item label="Nombres" required>
          <a-input v-model:value="formState.name" placeholder="Escribir aquí..." />
        </a-form-item>

        <a-form-item label="Apellidos" required>
          <a-input v-model:value="formState.lastname" placeholder="Escribir aquí..." />
        </a-form-item>
      </div>

      <a-form-item label="Correo" required>
        <a-input v-model:value="formState.email" placeholder="Escribir aquí..." />
      </a-form-item>

      <a-form-item label="Teléfono de contacto" required>
        <div class="flex">
          <SelectorCountry webphone style="width: 60px" @codePhone="formState.codePhone = $event" />

          <a-input v-model:value="formState.phone" placeholder="Número de celular" />
        </div>
      </a-form-item>

      <a-form-item label="Descripción de solicitud">
        <a-textarea
          v-model:value="formState.description"
          placeholder="Escribir aquí..."
          show-count
          :rows="4"
          :maxlength="500"
        />
      </a-form-item>
    </a-form>

    <template #footer>
      <a-button @click="handleClose">Cancelar</a-button>
      <a-button type="primary" :loading="loading" @click="sendRequest">Enviar solicitud</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import { useStore } from "vuex";
import { message } from "ant-design-vue";

import { UserData } from "@/@types/global";
import { ResponseError } from "@/app/shared/utils/httpManager";

import SelectorCountry from "@/app/shared/components/selectors/SelectorCountry.vue";
import SlotManager from "../../services/slots/SlotManager";

defineProps<{ open: boolean }>();

const emit = defineEmits<{ "update:open": [open: boolean] }>();

const store = useStore();

const formState = reactive({
  name: "",
  lastname: "",
  email: "",
  codePhone: "",
  phone: "",
  description: "",
});

const initialFormState = { ...formState };

const user = computed<UserData>(() => store.getters["getDataUser"]);

const handleClose = () => {
  emit("update:open", false);
  resetForm();
};

const manager = new SlotManager();
const loading = ref(false);

const sendRequest = async () => {
  loading.value = true;

  try {
    const { name, lastname, email, codePhone, phone, description } = formState;
    await manager.sendEmailRequest({
      first_name: name,
      last_name: lastname,
      email,
      description,
      phone_number: `${codePhone}${phone}`,
    });
    handleClose();
    message.success("Su mensaje fue enviado con éxito");
    console.log(formState, "");
    resetForm();
  } catch (e) {
    const errorMessage =
      e instanceof ResponseError ? e?.getErrorMessage?.() : "Ha ocurrido un error";
    message.error(errorMessage);
    console.error(e);
  }

  loading.value = false;
};
const resetForm = () => {
  Object.assign(formState, initialFormState);
};
</script>

<style scoped lang="sass">
h2
  color: $gray-9
  font-weight: 600
  font-size: 14px

.flex
  display: flex
  gap: 16px
</style>
